<template>
    <section class="assignment">

        <div class="panel">
            <div class="panel-heading">
                <h2>Assignment Submissions</h2>
            </div>
            <div class="panel-body">
                <ul class="list-group">
                    <li v-for="(assignment, index) in assignments" class="list-group-item">
                        <div class="row">
                            <div class="col-xs-12 col-sm-6">
                                {{assignment.student.firstName}} {{assignment.student.lastName}}<br>submitted on {{assignment.createdAt | localDate}}
                            </div>
                            <div class="col-xs-12 col-sm-3">
                                <a class="btn btn-success" v-bind:href="assignment.url">Download</a>
<!--                                 <button @click.prevent="showFeedbackForm(assignment)" class="btn btn-warning">Feedback</button>
 -->                            </div>
                            <div class="col-xs-12 col-sm-3 grade">
                                <input type="number" v-model="assignments[index].grade" class="form-control">
                                <button @click.prevent="gradeAssignment(assignment.id, assignments[index].grade,assignment.assignmentId, assignment.student.id, assignment.instanceId)" type="button" class="btn btn-primary tiny">Grade</button>
                            </div>
                        </div>
<!--                         <div class="row">
                            <div class="col-xs-12"><h3 @click="shownFeedback=assignment.id">Feedback</h3></div>
                            <ul class="list-group col-xs-12" v-if="shownFeedback==assignment.id">
                                <li v-for="item in assignment.feedback" class="list-group-item">
                                    <div class="panel">
                                    <div class="panel-heading"><h5>{{item.createdAt | localDate}}</h5></div>
                                        <div v-html="item.body" class="panel-body"></div>
                                    </div>
                                </li>
                            </ul>
                        </div> -->
       <!--                  <div class="feedback" v-if="selectedAssignment && selectedAssignment.id===assignment.id">
                            <form @submit.prevent="addFeedback">
                                <div class="form-group">
                                    <vue-html5-editor @change="updateContent" :content="content" :height="200"></vue-html5-editor>
                                </div>
                                <div class="form-group">
                                    <button class="btn btn-primary form-control">Send</button>
                                </div>
                            </form>
                        </div> -->
                    </li>

                </ul>


            </div>

        </div>
    </section>
</template>


<script>

    import assignments from '../services/assignments';
    import toastr from 'toastr';

    export default {
        data() {
            return {
                assignments: null,
                assignmentId: null,
                selectedAssignment: null,
                feedback: {
                    body: ''
                },
                shownFeedback:null
            }
        },
        mounted() {
            this.assignmentId = this.$route.params.assignmentId;
            this.getSubmissions();
        },
        methods: {
            gradeAssignment(id, grade, assignmentId, studentId, instanceId) {
                var self = this;
                var data = {
                    assignmentId: assignmentId,
                    studentId: studentId,
                    instanceId: instanceId,
                    grade: grade
                }
                assignments.grade(self, id, data).then(function(response) {
                    console.log(response);
                });
            },
            getSubmissions() {
                var self = this;

                assignments.getSubmissions(this, this.assignmentId).then(function(response) {
                    self.assignments = response.data;
                });
            },
            showFeedbackForm(assignment) {
                !this.selectedAssignment ? this.selectedAssignment = assignment : this.selectedAssignment = null;
            },
            updateContent(content) {
                this.feedback.body = content;
            },
            addFeedback() {
                var self = this;
                var feedback = {
                    body: self.feedback.body,
                    assignmentId: self.selectedAssignment.id,
                    populiId: self.selectedAssignment.assignmentId,
                    studentId: self.selectedAssignment.student.id,
                    instructorId: localStorage.account_id,
                    courseId: self.selectedAssignment.instanceId
                }
                assignments.addFeedback(self, feedback).then(function(response) {
                    response.data.success === true ? toastr.success(response.data.message) : toastr.error(response.data.message);
                    self.shownFeedback = self.selectedAssignment.id;
                    self.getSubmissions();
                    $('.content').html('');

                });
            }
        }
    }

</script>

<style lang="scss" scoped>

    .grade input {
        width:auto;
        float:left;
        max-width: 100px;
        margin-right:2rem;
    }


    .grade button {
        float:left;
        width:auto;
    }
    
</style>





// WEBPACK FOOTER //
// Assignment.vue?51960fc8